import {DashboardLayout} from 'components';
import CardSummary from 'components/CardSummary';
import {getStatusTextAndStyles} from 'helpers/getStatusTextAndStyles';
import React, {useMemo} from 'react';
import {Period} from 'routes/FraudDetection/Reconciliation/components/Period';
import InvoicesChart from './components/InvoicesChart';
import {Bank} from 'components/images/bank';
import {BalanceIcon} from 'components/images/balance';

function VeldroOverview() {
  const userAccountDetails = useMemo(
    () => ({
      business_name: 'Test Business',
      business_email: 'testbusiness@gmail.com',
      business_id: '94ND90NR',
    }),
    [],
  );

  return (
    <DashboardLayout
      bg="bg-white80"
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">Overview</p>
      }
    >
      <div className="grid lg:grid-cols-2 gap-4 pt-8">
        <div className="flex flex-col gap-3">
          <div className="bg-white rounded-lg p-8 shadow-cards border border-[#E4E7EC]">
            <div className="flex items-center gap-2">
              <BalanceIcon />

              <div className="flex flex-col gap-1 ">
                <p className="text-body  font-medium text-sm">
                  No. of Businesses
                </p>
                <>
                  <h2 className="font-semibold text-[24px] text-grey">1</h2>
                </>
              </div>
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-4 h-full">
            <CardSummary title="No. of Invoices" body="1" />
            <CardSummary title="Total amount of Invoices" body="₦53,750" />
          </div>
        </div>
        <div className="bg-white rounded-lg p-8  shadow-cards border border-[#E4E7EC]">
          <div className="flex items-center justify-between pb-3 border border-transparent border-b-[#E1E4EA]">
            <div className="flex items-center gap-2">
              <Bank />
              <p className="font-medium text-black text-base">
                Business Details
              </p>
            </div>
            <span
              className={`uppercase py-1 px-2 text-[10px] rounded-full ${
                getStatusTextAndStyles('active').styles
              }`}
            >
              {getStatusTextAndStyles('active').text || '-'}
            </span>
          </div>
          <div className="mt-4 flex flex-col gap-8">
            {Object.entries(userAccountDetails || {}).map(([key, value]) => (
              <div
                key={key}
                className="flex items-center justify-between text-sm"
              >
                <p className="text-[#868C98] capitalize">
                  {key === 'business_id'
                    ? key.replaceAll('_', ' ').replace(/id$/i, 'ID')
                    : key.replaceAll('_', ' ')}
                </p>
                <p className="text-black font-medium flex items-center font-inter gap-2">
                  {value || 'N/A'}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-white mt-10 rounded-lg p-6  shadow-cards border border-[#E4E7EC]">
        <div className="flex flex-col lg:flex-row lg:items-center gap-3 lg:gap-0 justify-between">
          <div className="flex items-center gap-6">
            <h1 className="text-deepBlue font-semibold text-[24px]">
              Invoices
            </h1>
            <div className="flex items-center gap-4 font-inter">
              <div className="text-[10px] font-medium text-body font-inter uppercase flex items-center gap-1">
                <div className="min-w-[16px] min-h-[16px] rounded bg-[#71B167]" />
                Confirmed
              </div>

              <div className="text-[10px] font-medium text-body  font-inter uppercase flex items-center gap-1">
                <div className="min-w-[16px] min-h-[16px] rounded bg-[#C0483F]" />
                Unconfirmed
              </div>
            </div>
          </div>
          <Period />{' '}
        </div>
        <div className="mt-7 grid md:grid-cols-2 lg:grid-cols-4 gap-3">
          <CardSummary
            title="Confirmed Invoices"
            body="0"
            className="bg-white80"
          />

          <CardSummary
            title="Unconfirmed Invoices"
            body="1"
            className="bg-white80"
          />
        </div>

        <InvoicesChart />
      </div>
    </DashboardLayout>
  );
}

export default VeldroOverview;
